/* unplugin-vue-components disabled */import { render } from "./DownloadYearHang.vue?vue&type=template&id=653aa676"
import script from "./DownloadYearHang.vue?vue&type=script&lang=js"
export * from "./DownloadYearHang.vue?vue&type=script&lang=js"

import "./DownloadYearHang.vue?vue&type=style&index=0&id=653aa676&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__